"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));

var isDateInRange = function isDateInRange(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      isSettingStartDate = _ref.isSettingStartDate,
      hoveredDate = _ref.hoveredDate,
      date = _ref.date;
  if (!startDate || !endDate && !hoveredDate) return false;
  var IsRangeSelected = !!endDate;

  if (IsRangeSelected) {
    return (0, _isWithinInterval["default"])(date, {
      start: startDate,
      end: endDate
    });
  }

  var isHoverdDate = !!hoveredDate;
  var isValidHoverdDate = hoveredDate > startDate;

  if (isHoverdDate && isValidHoverdDate && !isSettingStartDate) {
    return (0, _isWithinInterval["default"])(date, {
      start: startDate,
      end: hoveredDate
    });
  }

  return false;
};

var _default = isDateInRange;
exports["default"] = _default;